import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { useAsync } from "../lib/useAsync";

export function Teams() {
  const [showArchived, setShowArchived] = useState(false);
  const { data, loading, error, reload } = useAsync(
    () => api.listTeams(showArchived),
    [showArchived],
  );
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [msg, setMsg] = useState<string>();

  const create = async () => {
    if (!name.trim()) return;
    await api.createTeam(name.trim());
    setName("");
    reload();
  };
  const join = async () => {
    setMsg(undefined);
    try {
      await api.joinTeam(code.trim());
      setCode("");
      setMsg("Joined team.");
      reload();
    } catch (e) {
      setMsg((e as Error).message);
    }
  };

  const rename = async (teamId: string, current: string) => {
    const next = prompt("Rename team", current);
    if (!next || !next.trim() || next.trim() === current) return;
    await api.updateTeam(teamId, { name: next.trim() });
    reload();
  };
  const setArchived = async (teamId: string, archived: boolean) => {
    await api.updateTeam(teamId, { archived });
    reload();
  };
  const remove = async (teamId: string, teamName: string) => {
    if (
      !confirm(
        `Delete "${teamName}" permanently? This removes the team, its members, and join codes. This cannot be undone. Consider archiving instead.`,
      )
    )
      return;
    await api.deleteTeam(teamId);
    reload();
  };

  return (
    <div>
      <div className="row spread">
        <h1>Teams</h1>
        <label className="row" style={{ gap: "0.4rem" }}>
          <input
            type="checkbox"
            style={{ width: "auto" }}
            checked={showArchived}
            onChange={(e) => setShowArchived(e.target.checked)}
          />
          <span className="muted">Show archived</span>
        </label>
      </div>

      {loading && <p>Loading…</p>}
      {error && <p className="error">{error}</p>}

      {data?.items.map((t) => (
        <div key={t.teamId} className="card">
          <div className="row spread">
            <Link to={`/teams/${t.teamId}`}>
              <strong>{t.name ?? t.teamId}</strong>
            </Link>
            <span className="row" style={{ gap: "0.4rem" }}>
              {t.archived && <span className="badge cancelled">archived</span>}
              <span className="badge">{t.role}</span>
            </span>
          </div>
          {t.role === "admin" && (
            <div className="row" style={{ marginTop: "0.6rem" }}>
              <button
                className="secondary"
                onClick={() => rename(t.teamId, t.name ?? "")}
              >
                Rename
              </button>
              {t.archived ? (
                <button
                  className="secondary"
                  onClick={() => setArchived(t.teamId, false)}
                >
                  Unarchive
                </button>
              ) : (
                <button
                  className="secondary"
                  onClick={() => setArchived(t.teamId, true)}
                >
                  Archive
                </button>
              )}
              <button className="danger" onClick={() => remove(t.teamId, t.name ?? "")}>
                Delete
              </button>
            </div>
          )}
        </div>
      ))}
      {data && data.items.length === 0 && (
        <p className="muted">You're not on any teams yet.</p>
      )}

      <div className="card">
        <h2>Create a team</h2>
        <div className="row">
          <input
            placeholder="Team name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <button onClick={create}>Create</button>
        </div>
      </div>

      <div className="card">
        <h2>Join a team</h2>
        <div className="row">
          <input
            placeholder="Join code"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
          />
          <button onClick={join}>Join</button>
        </div>
        {msg && <p className="muted">{msg}</p>}
      </div>
    </div>
  );
}
